export type ProfileTab = 'events' | 'artists'

export const PROFILE_TABS: readonly ProfileTab[] = ['events', 'artists']
